import React from 'react';
import './Error404.css'; // Import your CSS file

const Error404 = () => {
  return (
    <div className="slide-in-element error-404">
      <h1>404 - Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <a href="/" className="button-error"><h2>Go to Home</h2></a>
    </div>
  );
};

export default Error404;
